// Preset options (in minutes) for the order closing-time offset — how long
// before closing the restaurant stops accepting pickup times, so customers
// can't choose to arrive exactly at closing.
const ORDERS_CLOSING_OFFSET_OPTIONS = [0, 15, 30, 45, 60, 90, 120];

// Returns the timezone's offset from UTC (in ms) at the given instant.
const timezoneOffsetMs = (date, timeZone) => {
  const parts = new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    hour: '2-digit',
    hourCycle: 'h23',
    minute: '2-digit',
    month: '2-digit',
    second: '2-digit',
    timeZone,
    year: 'numeric'
  })
    .formatToParts(date)
    .reduce((accumulator, part) => {
      if (part.type !== 'literal') accumulator[part.type] = Number(part.value);

      return accumulator;
    }, {});

  const wallTimeAsUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);

  return wallTimeAsUtc - date.getTime();
};

// Returns an ISO string for the next local midnight in the given timezone — used
// by "pause orders for today", so ordering auto-resumes at the start of tomorrow.
const getNextMidnightForTimezone = (timeZone) => {
  const safeTimeZone = timeZone || 'UTC';
  const now = new Date();

  const dateParts = new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: '2-digit',
    timeZone: safeTimeZone,
    year: 'numeric'
  })
    .formatToParts(now)
    .reduce((accumulator, part) => {
      if (part.type !== 'literal') accumulator[part.type] = Number(part.value);

      return accumulator;
    }, {});

  // Wall-clock target: tomorrow at 00:00 in the restaurant's timezone (Date.UTC
  // handles day overflow across month/year boundaries).
  const utcGuess = Date.UTC(dateParts.year, dateParts.month - 1, dateParts.day + 1, 0, 0, 0);
  const offset = timezoneOffsetMs(new Date(utcGuess), safeTimeZone);

  return new Date(utcGuess - offset).toISOString();
};

// True when ordering is temporarily paused (orders_paused_until is set and still
// in the future relative to `now`).
const isOrderingPaused = (ordersPausedUntil, now = new Date()) => {
  if (!ordersPausedUntil) return false;

  const pausedUntil = new Date(ordersPausedUntil);

  if (Number.isNaN(pausedUntil.getTime())) return false;

  return now < pausedUntil;
};

export {
  getNextMidnightForTimezone,
  isOrderingPaused,
  ORDERS_CLOSING_OFFSET_OPTIONS
};
